<template>
  <b-card>
			<div slot="header" class="align-text-bottom">
				<span style="line-height: 2rem;" v-html="caption"></span>
				<slot name="actions"></slot>
			</div>

		<b-row v-if="filter && !lazyFilterEnabled" class="flex-row-reverse">
			<b-col md="6" class="my-4">
				<b-form-group label-cols-sm="3" label="Search" class="mb-0">
					<b-input-group>
						<b-form-input v-model="filterText" placeholder="Type to Search"></b-form-input>
						<b-input-group-append>
							<b-button :disabled="!filter" @click="filterText = ''">Clear</b-button>
						</b-input-group-append>
					</b-input-group>
				</b-form-group>
			</b-col>
		</b-row>

		<b-row v-if="filter && lazyFilterEnabled" class="flex-row-reverse">
			<b-col md="6" class="my-4">
				<b-form-group label-cols-sm="3" label="" class="mb-0">
					<b-input-group>
						<b-form-input v-model="searchKeyword" v-on:keyup.enter="searchMethod(0, searchKeyword)" placeholder="Type to Search"></b-form-input>
						<b-input-group-append>
							<b-button :disabled="!filter" @click="searchMethod(0, searchKeyword)">Search</b-button>
						</b-input-group-append>
					</b-input-group>
				</b-form-group>
			</b-col>
		</b-row>

    <b-table :bordered="bordered" :current-page="currentPage" :dark="dark" :fields="captions" :filter="filterText" :fixed="fixed" :hover="hover" :items="items" :per-page="perPage" :small="small" :striped="striped" @filtered="onFiltered" responsive="sm" :busy="busy">
			<template v-slot:cell(version)="data">
				{{data.item.version.name}}
			</template>
			<template v-slot:cell(sendMail)="data">
				<b-badge :variant="getBadge(data.item.sendMail)">{{data.item.sendMail == true?'Yes':'No'}}</b-badge>
			</template>
			<template v-slot:cell(status)="data">
				<b-badge :variant="getBadge(data.item.status)" v-if="data.item.status==1">Active</b-badge>
				<b-badge :variant="getBadge(data.item.status)" v-if="data.item.status==0">Inactive</b-badge>
				<b-badge :variant="getBadge(data.item.status)" v-if="data.item.status==-1">Archived</b-badge>
			</template>
			<template v-slot:cell(approval_status)="data">
				<b-badge :variant="getApprovalBadge(data.item.approval_status)" v-if="data.item.approval_status">Approved</b-badge>
				<b-badge :variant="getApprovalBadge(data.item.approval_status)" v-if="!data.item.approval_status">Unapproved</b-badge>
			</template>
			<template v-slot:cell(payment_status)="data">
				<b-badge :variant="getPaymentBadge(data.item.payment_status)" v-if="data.item.payment_status===2">Paid</b-badge>
				<b-badge :variant="getPaymentBadge(data.item.payment_status)" v-if="data.item.payment_status===1">Partially Paid</b-badge>
				<b-badge :variant="getPaymentBadge(data.item.payment_status)" v-if="data.item.payment_status===0">Unpaid</b-badge>
			</template>
			<template v-slot:cell(delivery_status)="data">
				<b-badge :variant="getDeliveryBadge(data.item.delivery_status)" v-if="data.item.delivery_status">Delivered</b-badge>
				<b-badge :variant="getDeliveryBadge(data.item.delivery_status)" v-if="!data.item.delivery_status">Pending</b-badge>
			</template>
			<template v-slot:cell(actions)="row">
				<slot name="row-actions" :row="row"></slot>
			</template>
			<template v-slot:cell(avatar)="data">
				<b-avatar v-if="!data.item.pictureUrl || data.item.pictureUrl === ''"></b-avatar>
				<b-avatar v-else :src="data.item.pictureUrl"></b-avatar>
			</template>
			<template #table-busy>
				<div class="text-center my-2">
					<b-spinner label="Loading..." class="align-middle" variant="info"></b-spinner>
				</div>
			</template>
			<template v-slot:cell(loginEnabled)="data">
				<b-badge :variant="'success'" v-if="data.item.loginEnabled">Enabled</b-badge>
				<b-badge :variant="'danger'" v-if="!data.item.loginEnabled">Disabled</b-badge>
			</template>
    </b-table>

    <nav v-if="!lazyFilterEnabled">
      <b-pagination :total-rows="filteredTotal != null? filteredTotal : totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next"
                    hide-goto-end-buttons/>
    </nav>

		<nav v-if="lazyFilterEnabled">
			<pagination-links
				:page-index="filterAndPaginationStatus.currentPage"
				:search-method="searchMethod"
				:per-page="perPage"
				:page-count="filterAndPaginationStatus.totalPages"
			></pagination-links>
		</nav>
  </b-card>
</template>

<script>
  import PaginationLinks from "@/components/shared/PaginationLinks.vue";

	export default {
    name: 'g-table',
		components: {PaginationLinks},
    inheritAttrs: false,
    props: {
			filter:{
				type: Boolean,
				default:false
			},
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      },
      tableData: {
        type: [Array, Function],
        default: () => []
      },
      fields: {
        type: [Array, Object],
        default: () => []
      },
      perPage: {
        type: Number,
        default: 5
      },
      dark: {
        type: Boolean,
        default: false
      },
			busy: {
				type: Boolean,
				default: false
			},
			searchMethod: {
				type: Function,
				default: () => {}
			},
			lazyFilterEnabled: {
				type: Boolean,
				default: false
			},
			filterAndPaginationStatus: {
				type: Object,
				default: null
			}
    },
    data: () => {
      return {
				filteredTotal: null,
        currentPage: 1,
				filterText:null,
				searchKeyword: null
      }
    },
    computed: {
      items: function () {
        const items = this.tableData;
        return Array.isArray(items) ? items : items();
      },
      totalRows: function () {
        return this.getRowCount();
      },
      captions: function () {
        return this.fields;
      }
    },
    methods: {
      getBadge(status) {
        return status === 1 ? 'success'
          : status === 0 ? 'secondary'
            : status === -1 ? 'danger' : 'primary'
      },
			getApprovalBadge(status) {
				return status ? 'success' : 'danger'
			},
			getPaymentBadge(status) {
				return status === 2 ? 'success'
					: status === 1 ? 'warning'
						: status === 0 ? 'danger' : 'primary'
			},
			getDeliveryBadge(status) {
				return status ? 'success' : 'danger'
			},
      getRowCount: function () {
        return this.items.length
      },
			onFiltered(filteredItems) {
				// Trigger pagination to update the number of buttons/pages due to filtering
				this.filteredTotal = filteredItems.length;
				this.currentPage = 1
			},
			initLazyFilterAndPagination() {
				if(this.lazyFilterEnabled && !!this.filterAndPaginationStatus.searchKeyword){
					this.searchKeyword = this.filterAndPaginationStatus.searchKeyword;
				}
			}
    },
		created() {
			this.initLazyFilterAndPagination();
		}
	}
</script>
